import Carousel from "react-slick";
import styled, { css } from "styled-components";
import { getThemeMedia } from "../helpers";
import { getJustifyContent, getRowGap } from "./helper";
export const Slider = styled(Carousel) `
	margin: 0 auto;
	height: fit-content;

	&:hover {
		.slick-arrow.slick-prev,
		.slick-arrow.slick-next {
			opacity: ${({ arrows }) => (arrows ? 1 : 0)};
		}
	}

	.slick-arrow.slick-prev {
		opacity: ${({ hasHoverEffectArrows }) => (hasHoverEffectArrows ? 0 : 1)};
		left: -42px;
		transition: opacity 300ms ease-in-out;
	}

	.slick-track {
		display: flex !important;
	}

	.slick-arrow.slick-next {
		opacity: ${({ hasHoverEffectArrows }) => (hasHoverEffectArrows ? 0 : 1)};
		right: -42px;
		transition: opacity 300ms ease-in-out;
	}

	.slick-slide {
		display: flex;
		flex-direction: column;
		gap: ${({ rowGap, gap }) => getRowGap(rowGap, gap)};
		height: inherit !important;

		& > div {
			display: flex;
			height: 100% !important;
			justify-content: ${({ showNeighborhood, gap, slidesPerRow }) => getJustifyContent(showNeighborhood, slidesPerRow, gap)};
			${({ gap }) => gap &&
    css `
					gap: ${gap}px;
				`}
			${({ showNeighborhood, gap }) => showNeighborhood &&
    css `
					margin: 15px ${gap / 2}px;
				`};
		}
	}

	.slick-list {
		padding: 15px 0;
	}

	ul.slick-dots {
		position: relative;
		width: 90%;
		margin: 0 auto;

		@media screen {
			@media (min-width: ${getThemeMedia("medium")}) {
				width: 100%;
			}
		}

		li {
			button {
				border-radius: 50%;

				width: 15px;
				height: 15px;
			}

			&.slick-active button {
				background-color: var(--text-link);
			}

			&:not(.slick-active) button {
				background-color: var(--semantic-info-weak);
			}

			& button::before {
				display: none;
			}
		}
	}
`;
//# sourceMappingURL=styles.js.map